export const LOG_OUT = "LOG_OUT";
export const AUTHORIZED = "AUTHORIZED";
export const USER_INITIAL_LOADED = "USER_INITIAL_LOADED";